export const LOOM_NUDGE_REMIND_ME = 'twcg-2202-loom-nudge:remindMe';
export const LOOM_NUDGE_LAST_SHOWN_AT = 'twcg-2202-loom-nudge:lastShownAt';
